"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalFontsNames = exports.default = void 0;
var _styledComponents = require("styled-components");
var _universLight = _interopRequireDefault(require("./fonts/univers-light.woff"));
var _universLight2 = _interopRequireDefault(require("./fonts/univers-light.woff2"));
var _universRoman = _interopRequireDefault(require("./fonts/univers-roman.woff"));
var _universRoman2 = _interopRequireDefault(require("./fonts/univers-roman.woff2"));
var _universBold = _interopRequireDefault(require("./fonts/univers-bold.woff"));
var _universBold2 = _interopRequireDefault(require("./fonts/univers-bold.woff2"));
var _universBoldCond = _interopRequireDefault(require("./fonts/univers-bold-cond.woff"));
var _universBoldCond2 = _interopRequireDefault(require("./fonts/univers-bold-cond.woff2"));
var _universCond = _interopRequireDefault(require("./fonts/univers-cond.woff"));
var _universCond2 = _interopRequireDefault(require("./fonts/univers-cond.woff2"));
var _universBlack = _interopRequireDefault(require("./fonts/univers-black.woff"));
var _universBlack2 = _interopRequireDefault(require("./fonts/univers-black.woff2"));
var _hsdevilleRoman = _interopRequireDefault(require("./fonts/hsdeville-roman.woff"));
var _hsdevilleRoman2 = _interopRequireDefault(require("./fonts/hsdeville-roman.woff2"));
var _monotypeHelveticaDisplay = _interopRequireDefault(require("./fonts/monotype-helvetica-display.woff"));
var _monotypeHelveticaDisplay2 = _interopRequireDefault(require("./fonts/monotype-helvetica-display.woff2"));
var _monotypeHelveticaDisplayMedium = _interopRequireDefault(require("./fonts/monotype-helvetica-display-medium.woff"));
var _monotypeHelveticaDisplayMedium2 = _interopRequireDefault(require("./fonts/monotype-helvetica-display-medium.woff2"));
var _monotypeHelveticaDisplayBold = _interopRequireDefault(require("./fonts/monotype-helvetica-display-bold.woff"));
var _monotypeHelveticaDisplayBold2 = _interopRequireDefault(require("./fonts/monotype-helvetica-display-bold.woff2"));
var _tradeGothicLtstdBdcn = _interopRequireDefault(require("./fonts/trade-gothic-ltstd-bdcn20.woff"));
var _tradeGothicLtstdBdcn2 = _interopRequireDefault(require("./fonts/trade-gothic-ltstd-bdcn20.woff2"));
var _robotomonoRegular = _interopRequireDefault(require("./fonts/robotomono-regular.woff"));
var _robotomonoRegular2 = _interopRequireDefault(require("./fonts/robotomono-regular.woff2"));
var _helveticaneue = _interopRequireDefault(require("./fonts/helveticaneue.woff"));
var _helveticaneue2 = _interopRequireDefault(require("./fonts/helveticaneue.woff2"));
var _helveticaneueBold = _interopRequireDefault(require("./fonts/helveticaneue-bold.woff"));
var _helveticaneueBold2 = _interopRequireDefault(require("./fonts/helveticaneue-bold.woff2"));
var _universRoundedBlack = _interopRequireDefault(require("./fonts/univers-rounded-black.woff"));
var _universRoundedBlack2 = _interopRequireDefault(require("./fonts/univers-rounded-black.woff2"));
var _universRoundedLight = _interopRequireDefault(require("./fonts/univers-rounded-light.woff"));
var _universRoundedLight2 = _interopRequireDefault(require("./fonts/univers-rounded-light.woff2"));
var _universRoundedRoman = _interopRequireDefault(require("./fonts/univers-rounded-roman.woff"));
var _universRoundedRoman2 = _interopRequireDefault(require("./fonts/univers-rounded-roman.woff2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const globalFontsNames = ['univers-light', 'univers-roman', 'univers-cond', 'univers-bold-cond', 'univers-black', 'hs-deville', 'monotype-helvetica-display', 'monotype-helvetica-display-medium', 'monotype-helvetica-display-bold', 'trade-gothic', 'robotomono-regular', 'helvetica-neue', 'helvetica-neue-bold'];
exports.globalFontsNames = globalFontsNames;
const GlobalFonts = (0, _styledComponents.createGlobalStyle)`
  body {
    margin: 0px;
  } 

  #___gatsby {
    overflow-x: hidden;
  }

  @font-face {
    font-family: "univers-light";
    src: local("univers-light"),
      url(${_universLight2.default}) format("woff2"),
      url(${_universLight.default}) format("woff");
  }

  @font-face {
    font-family: "univers-roman";
    src: local("univers-roman"),
      url(${_universRoman2.default}) format("woff2"),
      url(${_universRoman.default}) format("woff");
  }

  @font-face {
    font-family: "univers-cond";
    src: local("univers-cond"),
      url(${_universCond2.default}) format("woff2"),
      url(${_universCond.default}) format("woff");
  }

  @font-face {
    font-family: "univers-bold";
    src: local("univers-bold"),
      url(${_universBold2.default}) format("woff2"),
      url(${_universBold.default}) format("woff");
  }

  @font-face {
    font-family: "univers-bold-cond";
    src: local("univers-bold-cond"),
      url(${_universBoldCond2.default}) format("woff2"),
      url(${_universBoldCond.default}) format("woff");
  }

  @font-face {
    font-family: "univers-black";
    src: local("univers-black"),
      url(${_universBlack2.default}) format("woff2"),
      url(${_universBlack.default}) format("woff");
  }

  @font-face {
    font-family: "hs-deville";
    src: local("hs-deville"),
      url(${_hsdevilleRoman2.default}) format("woff2"),
      url(${_hsdevilleRoman.default}) format("woff");
  }

  @font-face {
    font-family: "monotype-helvetica-display";
    src: local("monotype-helvetica-display"),
      url(${_monotypeHelveticaDisplay2.default}) format("woff2"),
      url(${_monotypeHelveticaDisplay.default}) format("woff");
  }

  @font-face {
    font-family: "monotype-helvetica-display-medium";
    src: local("monotype-helvetica-display-medium"),
      url(${_monotypeHelveticaDisplayMedium2.default}) format("woff2"),
      url(${_monotypeHelveticaDisplayMedium.default}) format("woff");
  }

  @font-face {
    font-family: "monotype-helvetica-display-bold";
    src: local("monotype-helvetica-display-bold"),
      url(${_monotypeHelveticaDisplayBold2.default}) format("woff2"),
      url(${_monotypeHelveticaDisplayBold.default}) format("woff");
  }

  @font-face {
    font-family: "trade-gothic";
    src: local("trade-gothic"),
      url(${_tradeGothicLtstdBdcn2.default}) format("woff2"),
      url(${_tradeGothicLtstdBdcn.default}) format("woff");
  }

  @font-face {
    font-family: "robotomono-regular";
    src: local("robotomono-regular"),
      url(${_robotomonoRegular2.default}) format("woff2"),
      url(${_robotomonoRegular.default}) format("woff");
  }

  @font-face {
    font-family: "helvetica-neue";
    src: local("helvetica-neue"),
      url(${_helveticaneue2.default}) format("woff2"),
      url(${_helveticaneue.default}) format("woff");
  }


  @font-face {
    font-family: "helvetica-neue-bold";
    src: local("helvetica-neue-bold"),
      url(${_helveticaneueBold2.default}) format("woff2"),
      url(${_helveticaneueBold.default}) format("woff");
  }

  @font-face {
    font-family: "univers-rounded-black";
    src: local("univers-rounded-black"),
      url(${_universRoundedBlack2.default}) format("woff2"),
      url(${_universRoundedBlack.default}) format("woff");
  }

  @font-face {
    font-family: "univers-rounded-light";
    src: local("univers-rounded-light"),
      url(${_universRoundedLight2.default}) format("woff2"),
      url(${_universRoundedLight.default}) format("woff");
  }

  @font-face {
    font-family: "univers-rounded-roman";
    src: local("univers-rounded-roman"),
      url(${_universRoundedRoman2.default}) format("woff2"),
      url(${_universRoundedRoman.default}) format("woff");
  }
  
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
var _default = GlobalFonts;
exports.default = _default;
//# sourceMappingURL=index.js.map